import type { RiskSnapshot } from "../api/markets";

function bar(value: number, color: string) {
  return (
    <div className="risk-bar">
      <div
        className="risk-bar-fill"
        style={{ width: `${Math.min(100, Math.max(0, value))}%`, background: color }}
      />
    </div>
  );
}

export function RiskCard({ risk }: { risk: RiskSnapshot }) {
  return (
    <div className="risk-card">
      <div className="risk-header">
        <h3>Risk &amp; regime</h3>
        <span className={`risk-confidence risk-confidence-${risk.confidence}`}>
          {risk.confidence} confidence
        </span>
      </div>
      <div className="risk-row">
        <span>Liquidation pressure</span>
        <strong>{risk.liquidation_pressure.toFixed(0)}</strong>
      </div>
      {bar(risk.liquidation_pressure, "#ff5c8a")}
      <div className="risk-row">
        <span>Volatility regime</span>
        <strong>{risk.volatility_regime.toFixed(0)}</strong>
      </div>
      {bar(risk.volatility_regime, "#ffb454")}
      <div className="risk-row">
        <span>Spread anomaly</span>
        <strong>{risk.spread_anomaly.toFixed(0)}</strong>
      </div>
      {bar(risk.spread_anomaly, "#5af2c2")}
      <div className="risk-row">
        <span>Exchange divergence</span>
        <strong>{risk.exchange_divergence.toFixed(0)}</strong>
      </div>
      {bar(risk.exchange_divergence, "#7c8dff")}
      <p className="risk-explain">{risk.explanation}</p>
      <p className="risk-disclaimer">Informational only. Not financial advice.</p>
    </div>
  );
}
